import OffcanvasEditarDadoHeader from "./OffcanvasEditarDadoHeader";
import OffcanvasEditarDadoBody from "./OffcanvasEditarDadoBody";
import OffcanvasEditarDadoRoot from "./OffcanvasEditarDadoRoot";

export const OffcanvasEditarDado = {
    Root: OffcanvasEditarDadoRoot,
    Header: OffcanvasEditarDadoHeader,
    Body: OffcanvasEditarDadoBody,
};